import { addEvent } from './_events';
export class MediaCarousel {
  constructor(carousel) {
    this.buttonLeft = carousel.querySelector('.js-thumbnail-carousel-left');
    this.buttonRight = carousel.querySelector('.js-thumbnail-carousel-right');
    this.content = carousel.querySelector('.js-thumbnail-carrousel-content');
    const elements = carousel.querySelector('[data-number-images]');
    if (!elements) {
      return false;
    }
    this.numberOfImages = Number(elements.dataset.numberImages);
    this.position = 1;
    this.move();
    addEvent(carousel, 'click', () => this._left(), '.js-thumbnail-carousel-left', this);
    addEvent(carousel, 'click', () => this._right(), '.js-thumbnail-carousel-right', this);
  }
  _left() {
    this.position--;
    this.position = Math.max(this.position, 1);
    this.move();
  }
  _right() {
    this.position++;
    this.position = Math.min(this.position, this.numberOfImages);
    this.move();
  }
  move() {
    this.buttonLeft.disabled = this.position == 1;
    this.buttonRight.disabled = this.position == this.numberOfImages;
    this.content.style.transform = 'translateX(-' + (this.position - 1) * 100 + '%)';
  }
}